import "./EmptyCalendar.css";
import UndrawCalendar from "../../assets/undraw_calendar.svg";
import Translatable from "../Translatable/Translatable";

function EmptyCalendar() {
  return (
    <div className="calendar-image-container">
      <img
        className="calendar-image"
        src={UndrawCalendar}
        alt="Calendario vacio"
      />
      <p className="empty-calendar-msg">
        <Translatable as="span">
          Seleccioná tus materias para empezar a completar y organizar tu calendario
        </Translatable>
      </p>
    </div>
  );
}

export default EmptyCalendar;
